import React, {useEffect, useState} from 'react';
import {message} from 'antd';
import {getSecInfo} from '~/service/sec';

function Html(props) {
    const {match: {params: {id}}} = props;
    const [secContent, setSecContent] = useState('');

    useEffect(() => {
        getSecInfo({id})
            .then(({data}) => {
                const {secContent} = data;
                setSecContent(secContent);
            })
            .catch(() => {
                message.info('获取HTML信息失败');
            });
    }, []);

    return (
        <div
            dangerouslySetInnerHTML={{__html: secContent}}
        >
        </div>

    );
}

export default Html;
